import { getVendorBusinessImageUrl } from "../helpers/mediaUrl";

export default class vendorServicing_dashboard {
  constructor() {
    this.bindEvents();
  }

  bindEvents = () => {
    this.isVendorLoggedIn();

    this.get_days_weeks_data("Today");
    this.get_days_weeks_data("Week");
    this.get_days_weeks_data("TillDate");
    this.get_Vendor_Summary_For_VendorURL();

    // Bind shortcuts
    $(".vendor-nav-shortcut").on("click", (event) => {
        const page = $(event.currentTarget).attr("data-page");
        const dummyEvent = { 
            currentTarget: { 
                classList: {
                    0: "dummy",
                    1: page,
                    add: () => {},
                    remove: () => {}
                }
            } 
        };
        
        // Use the navbar instance to handle routing
        if (window.vendorServicing_navbar) {
            window.vendorServicing_navbar.sidebarFunctionVendor(dummyEvent);
        } else {
            $(`#sidebarMenu .${page}`).click();
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // Back to Dashboard button logic
    $("#vendorBackToDashboard").on("click", () => {
        this.navigateToDashboard();
    });
  };

  navigateToDashboard = () => {
    $(".currentlyActive").addClass("d-none").removeClass("currentlyActive");
    $(".VendorDashboardPage").addClass("currentlyActive").removeClass("d-none");
    $("#vendorBackToDashboard").addClass("d-none");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  isVendorLoggedIn = () => {
    {
      $.ajax({
        type: "GET",
        url: baseURL + "api/vendor/isVendorLoggedIn",

        headers: { Authorization: X_API_KEY },

        success: (res) => {
          if (res == false) {
            window.location = baseURL + "Vendor_login";
            alert("Please Login First");
          }
        },
      });
    }
  };

  get_days_weeks_data = (Filter_para) => {
    $.ajax({
      type: "POST",
      url: baseURL + "api/vendor/Dashboard",
      data: { Filter: Filter_para },
      headers: { Authorization: X_API_KEY },
      success: (res) => this.display_premium_data(res, Filter_para),
    });
  };

  display_premium_data = (res, Filter_para) => {
    if (Filter_para == "TillDate") {
      $(".count-total-enquiries").text(res.Total_order || 0);
      $(".count-received").text(res.OrderReceived || 0);
      $(".count-delivered").text(res.OrderDelivered || 0);
      $(".count-pending").text(res.OrderPending || 0);
    } else {
      const targetId = Filter_para === "Today" ? "#vendorTodayStats" : "#vendorWeekStats";
      const statsHtml = `
        <div class="activity-item d-flex align-items-center mb-3">
            <div class="activity-icon bg-light p-2 rounded-3 me-3">
                <i class="fa-solid fa-file-invoice text-primary"></i>
            </div>
            <div class="flex-grow-1">
                <div class="d-flex justify-content-between">
                    <span class="small fw-bold">Total Enquiries</span>
                    <span class="small fw-bold text-primary">${res.Total_order || 0}</span>
                </div>
                <div class="progress mt-1" style="height: 4px;">
                    <div class="progress-bar" style="width: 100%"></div>
                </div>
            </div>
        </div>
        <div class="activity-item d-flex align-items-center mb-3">
            <div class="activity-icon bg-light p-2 rounded-3 me-3">
                <i class="fa-solid fa-clock-rotate-left text-warning"></i>
            </div>
            <div class="flex-grow-1">
                <div class="d-flex justify-content-between">
                    <span class="small fw-bold">Pending</span>
                    <span class="small fw-bold text-warning">${res.OrderPending || 0}</span>
                </div>
                <div class="progress mt-1" style="height: 4px;">
                    <div class="progress-bar bg-warning" style="width: ${res.Total_order > 0 ? (res.OrderPending / res.Total_order * 100) : 0}%"></div>
                </div>
            </div>
        </div>
        <div class="activity-item d-flex align-items-center">
            <div class="activity-icon bg-light p-2 rounded-3 me-3">
                <i class="fa-solid fa-check-double text-success"></i>
            </div>
            <div class="flex-grow-1">
                <div class="d-flex justify-content-between">
                    <span class="small fw-bold">Delivered</span>
                    <span class="small fw-bold text-success">${res.OrderDelivered || 0}</span>
                </div>
                <div class="progress mt-1" style="height: 4px;">
                    <div class="progress-bar bg-success" style="width: ${res.Total_order > 0 ? (res.OrderDelivered / res.Total_order * 100) : 0}%"></div>
                </div>
            </div>
        </div>
      `;
      $(targetId).find(".activity-item").remove(); // Clear old items but keep header
      $(targetId).append(statsHtml);
    }
  };

  get_Vendor_Summary_For_VendorURL = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/getVendorDetails",
      headers: { Authorization: X_API_KEY },
      success: (res) => {
          this.getVenderURL(res);
          $(".vendorNameDisplay").text(res.Business_Name);
          
          // Populate avatar
          const avatarContainer = $(".vendorProfileImage.dashboard-avatar");
          const imageUrl = getVendorBusinessImageUrl(res.Image_URL, 1);
          avatarContainer.html(`<img src="${imageUrl}" style="width: 100%; height: 100%; object-fit: cover;" onerror="this.src='https://img.icons8.com/material-rounded/48/ffffff/guest-male.png';">`);
      },
    });
  };
  getVenderURL = (res) => {
    var fullVendorURL = baseURL + "customer/productListing/" + res.Vendor_URL;

    $("#vendorUrlInput").val(fullVendorURL);
    $("#vendorUrlCopyButton").on("click", this.doCopyVendorURL);

    // Populate custom website link if active
    if (res.Custom_Website_Url) {
      $("#customWebsiteUrlInput").val(res.Custom_Website_Url);
      $("#customWebsiteUrlLink").attr("href", res.Custom_Website_Url);
      $("#customWebsiteUrlContainer").removeClass("d-none").addClass("d-flex");
      $("#dashboardWebsiteLiveBadge").removeClass("d-none");
    } else {
      $("#customWebsiteUrlContainer").addClass("d-none").removeClass("d-flex");
      $("#dashboardWebsiteLiveBadge").addClass("d-none");
    }
  };

  doCopyVendorURL = () => {
    const urlInput = document.getElementById("vendorUrlInput");

    // Create a range and select the text
    const range = document.createRange();
    range.selectNode(urlInput);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);

    try {
      // Use the Clipboard API to copy the text
      document.execCommand("copy");
      // alert("URL copied to clipboard!");
    } catch (err) {
      // alert("Oops, unable to copy to clipboard. Manually copy the URL.");
    } finally {
      // Clear the selection
      window.getSelection().removeAllRanges();
    }
  };
}

